//#region src/hubble.ts
const TIQ_HUBBLE_EVENT_NAME = "tealium_iq_event";
const forwardHubbleEventsIntoTealium = (hubble, track) => {
	hubble.on("send", (events) => {
		for (const event of events) {
			if (event.name === TIQ_HUBBLE_EVENT_NAME) continue;
			track("link", {
				...event,
				isHubbleEvent: true
			});
		}
	});
};

//#endregion
export { forwardHubbleEventsIntoTealium };
//# sourceMappingURL=hubble.js.map